// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610221035/js/" + chunkId + "." + {"44":"9dfc5040","225":"6f1c5b0a","481":"6d31b5ea","486":"e19904e4","770":"8c04786f"}[chunkId] + ".0.16850372539186076.chunk.js";
};